module.exports = __webpack_public_path__ + "static/img/dq6.1cdf019.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic/dq6.png
// module id = FFdE
// module chunks = 0